import { render, staticRenderFns } from "./DialogBaixarDae.vue?vue&type=template&id=31b8ff1b"
import script from "./DialogBaixarDae.vue?vue&type=script&lang=js"
export * from "./DialogBaixarDae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports